import createDataContext from '@src/context/createDataContext';
import { HOST, makeGetApiRequest, makePostApiRequest } from '@common/index';
import axios from 'axios';
import { showAlert } from '@common/helper';

// const HOST1 = "https://refurbishment-dev-1.spinny.com";

interface StateType {
    validationListData: any;
    filterListing: any;
    inspectionCarPhotos: any;
    validationDetails: any;
    validationHistory: any;
    validatorList: any;
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    validationListData: [],
    filterListing: [],
    inspectionCarPhotos: [],
    validationDetails: [],
    validationHistory: [],
    validatorList: []
}

const reducer = (state, action: ActionType) => {

    switch (action.type) {
        case 'setValidationListData': return { ...state, validationListData: action.payload }

        case 'setFilterListing': return { ...state, filterListing: action.payload }

        case 'setInspectionCarPhotos': return { ...state, inspectionCarPhotos: action.payload }

        case 'setValidationDetails': return { ...state, validationDetails: action.payload }

        case 'setValidationHistory': return { ...state, validationHistory: action.payload }

        case 'setValidatorList': return { ...state, validatorList: action.payload }

        default: return state
    }

}

export const getValidationListData = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { workshopId, activeCases, search, orderBy, page, filters } = variables;
            const url = `${HOST}/inspection-validation/get-validation-listing/v2?workshop_id=${workshopId}&per_page=15&page=${page}&order_by=${orderBy}&search=${search}&active_cases=${activeCases}&filters=${JSON.stringify(filters)}`;
            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            dispatch({ type: 'setValidationListData', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST validation list ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e) : null
        }

    }

}

export const getFilterListing = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { workshopId } = variables;
            const url = `${HOST}/inspection-validation/get-filters-for-validation-listing/${workshopId}`;
            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');
            
            dispatch({ type: 'setFilterListing', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('GET validation filter ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const getInspectionCarPhotos = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { refurbCarId, journeyId } = variables;
            const url = `${HOST}/inspection/get-inspection-car-photos?refurb_car_id=${refurbCarId}&journey_id=${journeyId}`;
            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');
            
            dispatch({ type: 'setInspectionCarPhotos', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('GET inspection car photos ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const getValidationDetails = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId } = variables;
            const url = `${HOST}/inspection-validation/get-validation-details/${jobListId}`;
            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            dispatch({ type: 'setValidationDetails', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('GET validation details ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const completeValidation = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId, validatorId } = variables;
            const url = `${HOST}/inspection-validation/complete-validation`;
            const data = {
                job_list_id: jobListId,
                validator_id: validatorId,
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST validation complete ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const getValidationHistory = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId } = variables;
            const url = `${HOST}/inspection-validation/get-validation-history/${jobListId}`;
            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            dispatch({ type: 'setValidationHistory', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('GET validation history ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const reassignValidator = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId, currentValidatorId, newValidatorId, subJobRowIds } = variables;
            const url = `${HOST}/inspection-validation/re-assign-validator`;
            const data = {
                job_list_id: jobListId,
                current_validator_id: currentValidatorId,
                new_validator_id: newValidatorId,
                sub_job_row_ids: subJobRowIds,
            }

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST reassign validator ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const assignValidator = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId } = variables;
            const url = `${HOST}/inspection-validation/assign-validator`;
            const data = {
                job_list_id: jobListId,
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            showAlert(e?.response?.data?.['error message'] ?? e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const getValidatorList = dispatch => {
    return async (variables, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            let { jobListId, validator } = variables;
            const url = `${HOST}/inspection-validation/get-validators-for-reassignment/${jobListId}?validator=${validator}`;

            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            dispatch({ type: 'setValidatorList', payload: response?.data })

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('GET validator list ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export const validateIssue = dispatch => {
    return async (variables, token, callback?: (data?) => void, err_callback?: (message) => void) => {

        try {
            const url = `${HOST}/inspection-validation/validate-issue`;
            const data = {
                ...variables
            };

            const response = await makePostApiRequest(url, data, {}, 'Keycloak-Authorization', 'Bearer', 'refurb');

            !!callback ? callback?.(response.data) : null

        } catch (e) {
            console.log('POST validate issue ERROR', e)
            showAlert(e?.response?.data?.message, 'error')
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface ValidationInterface {
    state: StateType,
    getValidationListData: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getFilterListing: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getInspectionCarPhotos: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getValidationDetails: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    completeValidation: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getValidationHistory: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    reassignValidator: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    assignValidator: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getValidatorList: (variables, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    validateIssue: (variables, token, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,

}

export const { Context: ValidationContext, Provider: ValidationProvider } = createDataContext(reducer,
    {
        getValidationListData,
        getFilterListing,
        getInspectionCarPhotos,
        getValidationDetails,
        completeValidation,
        getValidationHistory,
        reassignValidator,
        assignValidator,
        getValidatorList,
        validateIssue,
    },
    initialState)
